<template>
  <div>
    <ReportCrossTable module="Financeiro" name="Relatório de Desempenho Financeiro" urlGet="/api/v1/finance/report/dre"
      :filters="filters" />

    <Modal title="Lançamentos" :width="1100" :height="750" v-if="showModal('details')">
      <Loading :center="false" v-show="loading" />
      <SubReport name="Lançamentos" v-show="!loading" :titleHeader="subReport.title" :minHeight="500"
        :header="subReport.fields" :data="subReport.data" :totalizationCustom="subReport.totalization" />
    </Modal>
  </div>
</template>

<script>

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import SubReport from "@nixweb/nixloc-ui/src/component/shared/Report";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import ReportCrossTable from '../../../components/modules/finance/dre/ReportCrossTable.vue'

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "DrePayableReceivable",
  components: {
    Modal, SubReport, Loading, ReportCrossTable
  },
  data() {
    return {
      urlGetSubReportApi: "/api/v1/finance/report/sub-dre",
      filters: [
        {
          type: "multiOptions",
          title: "Centro de Custo",
          field: "CostCenterName",
          url: "/api/v1/finance/cost-center/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Conta Bancária",
          field: "BankAccountName",
          url: "/api/v1/finance/bank-account/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "date",
          title: "Data de Cadastro",
          field: "RegisteredDate",
          value: "",
          required: true,
        },
        {
          type: "date",
          title: "Data de Competência",
          field: "CompetenceDate",
          value: "",
          required: true,
        },
        {
          type: "date",
          title: "Data de Conciliação",
          field: "ConciliationDate",
          value: "",
          required: true,
        },
        {
          type: "date",
          title: "Data de Vencimento",
          field: "DueDate",
          value: "",
          required: true,
        },
        {
          type: "text",
          title: "Descrição",
          field: "Description",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Destinatário",
          field: "RecipientName",
          url: "/api/v1/finance/payable-receivable/select-all-recipient",
          propsParams: {},
          value: "",
        },
        {
          type: "text",
          title: "Documento",
          field: "Document",
          value: "",
        },
        {
          type: "options",
          title: "Pagar ou Receber",
          field: "TypeName",
          options: [
            { text: "Pagar", value: "Pagar" },
            { text: "Receber", value: "Receber" },
          ],
          value: [],
        },
        {
          type: "multiOptions",
          title: "Plano de Conta",
          field: "ChartOfAccountsName",
          url: "/api/v1/finance/chart-of-accounts/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "options",
          title: "Pago/Recebido",
          field: "PaidName",
          options: [
            { text: "Sim", value: "Sim" },
            { text: "Não", value: "Não" },
          ],
          value: [],
        },
        {
          type: "options",
          title: "Status",
          field: "Status",
          options: [
            { text: "Agendada", value: "Agendada" },
            { text: "Pago", value: "Pago" },
            { text: "Recebido", value: "Recebido" },
            { text: "Pendente", value: "Pendente" },
          ],
          value: [],
        },
        {
          type: "multiOptions",
          title: "Tipo de Pagamento",
          field: "TypePaymentName",
          url: "/api/v1/finance/type-payment/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "decimal",
          title: "Valor",
          field: "Value",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Desconto",
          field: "Discount",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Multa",
          field: "Fees",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Geral",
          field: "General",
          valueStart: 0,
          valueEnd: 0,
        },
      ],
      subReport: {
        title: "",
        fields: [
          {
            field: "recipientName",
            title: "Destinatário",
            type: "text",
            styleHeader: "width:250px;",
            styleBody: "max-width: 240px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
          },
          {
            field: "description",
            title: "Descrição",
            type: "text",
            styleHeader: "width:300px;",
            styleBody: "max-width: 500px; overflow-wrap: break-word; word-break: break-word;",
          },
          {
            field: "dueDateStr",
            title: "Dt Vencimento",
            type: "text",
          },
          {
            field: "competenceDateStr",
            title: "Dt Competência",
            type: "text",
          },
          {
            title: "R$ Valor",
            field: "generalStr",
            type: "text",
          },
        ],
        data: [],
        totalization: [],
      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters("generic", ["event", "showModal"]),
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["openModal", "hideModal"]),
    getAll(ids) {
      this.loading = true;
      let params = {
        url: this.urlGetSubReportApi,
        obj: { ids: ids },
        notNotifyToast: true
      };
      this.postApi(params).then((response) => {
        this.subReport.data = response.content.data;
        this.subReport.totalization = response.content.totalization;
        this.loading = false;
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "details") {
          this.subReport.title = event.data.title;
          this.openModal("details");
          this.getAll(event.data.ids);
        }
      },
      deep: true,
    },
  },
}


</script>